module.exports = __webpack_public_path__ + "img/sc.4b415458.png";